// React and hooks
import { useEffect, useState } from "react";

// State management
import { useAppSelector } from "../../services/StoreHelper";

// Internal components and styles
import Link from "./Link/Link";
import footer_styles from "./footer_styles";

// Utilities
import { normalizeUrl } from "../../services/global.services";

function Footer() {
  const { app_dimensions, club } = useAppSelector((state) => state.app);

  // Local state to track dimensions and respond to resize
  const [dimensions, setDimensions] = useState(app_dimensions);

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 950;
      setDimensions({
        mobile: isMobile,
        desktop: !isMobile,
      });
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // initialize on mount

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const styles = footer_styles(dimensions);

  const links = [
    { text: "Website", url: club.websiteUrl },
    { text: "Privacy Policy", url: club.privacyPolicyUrl },
    { text: "Terms of Service", url: club.termsOfServiceUrl },
  ];

  return (
    <div
      style={{
        ...styles.footer_container,
        justifyContent: dimensions.desktop ? undefined : "center",
      }}
    >
      <div style={styles.buttons}>
        {links.map(({ text, url }, i) => (
          <Link key={i} link={normalizeUrl(url)} link_text={text} />
        ))}
      </div>
    </div>
  );
}

export default Footer;